<script lang="ts">
  import { brandStore } from '@/lib/brandStore.svelte';

  let {
    compact = false,
    statusLabel = '',
    title = '',
    showBack = false,
    onBack,
  }: {
    compact?: boolean;
    statusLabel?: string;
    title?: string;
    showBack?: boolean;
    onBack?: () => void;
  } = $props();

  const cfg = $derived(brandStore.config);
</script>

<header class="header">
  <div class="header-brand">
    {#if showBack && onBack}
      <button class="header-back-btn" type="button" onclick={onBack} aria-label="Voltar">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
    {/if}
    <img class="header-logo" src={cfg?.brand.logoUrl ?? '/logo.png'} alt={cfg?.app.name ?? 'AutoParts Vision'} />
    {#if title}
      <span class="header-title" id="screen-title">{title}</span>
    {:else}
      <span class="header-title">{cfg?.app.name ?? 'AutoParts Vision'}</span>
      <span class="header-badge">{cfg?.app.tagline ?? 'AI Scanner'}</span>
    {/if}
  </div>
  <div class="header-actions">
    <span class="header-badge" style="background: var(--accent-green-alpha-15); border-color: var(--accent-green-alpha-25); color: var(--accent-green);">
      {statusLabel || 'Online'}
    </span>
  </div>
</header>

<style>
  .header-back-btn {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #cbd5e1;
    transition: background 0.2s;
    flex-shrink: 0;
    padding: 0;
  }

  .header-back-btn:hover {
    background: rgba(255, 255, 255, 0.12);
  }
</style>
